/*
 * @Author: 梅豆
 * @Date: 2023-04-21 10:20:02
 * @LastEditors: 梅豆
 * @LastEditTime: 2023-04-21 10:27:24
 * @Description: 
 * @FilePath: \spm-fe-trunkd:\zdys\防汛抗旱应急支持系统\ys.fxkh_yzt\src\store\modules\urlConfig.js
 */
// 系统公共配置
const state = {
    XServiceUrl:'https://yyzc-fxkh.hbsis.gov.cn:31443'
}

export default{
    state
}